import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../app/components/buttons/primary";
import { startSsoLogin } from "../../app/utils/msalInstance";
import { isSessionEnded } from "../../app/utils/sessionEnded";
import { consumeReturnUrl } from "../../app/utils/sessionReturnUrl";

const Goodbye = () => {
  const isAuthenticated = useIsAuthenticated();
  const sessionEnded = isSessionEnded();
  const navigate = useNavigate();
  const loginStarted = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !sessionEnded) {
      navigate(consumeReturnUrl(), { replace: true });
    }
  }, [isAuthenticated, sessionEnded, navigate]);

  const handleClick = async () => {
    if (loginStarted.current) {
      return;
    }
    loginStarted.current = true;
    try {
      await startSsoLogin();
    } catch (error) {
      console.error("Sign in redirect failed:", error);
      loginStarted.current = false;
    }
  };

  if (isAuthenticated && !sessionEnded) {
    return (
      <Container>
        <LogoutBox>
          <h2>Redirecting...</h2>
        </LogoutBox>
      </Container>
    );
  }

  return (
    <Container>
      <LogoutBox>
        <h2>You are Logged Out</h2>
        <span>Thank you for using Predict</span>
        <PrimaryButton onClick={handleClick} style={{ width: "100%" }}>
          Sign in
        </PrimaryButton>
      </LogoutBox>
    </Container>
  );
};

export default Goodbye;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 91px);
`;

const LogoutBox = styled.div`
  width: 500px;
  height: 300px;
  background-color: var(--White);
  padding: 1em 2em;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 2em;
  justify-content: center;
  align-items: center;
`;
